import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-general-error',
    templateUrl: './general-error.component.html',
    styleUrls: ['./general-error.component.scss'],
    standalone: false
})

/**
 * Maintenance Component
 */
export class GeneralErrorComponent implements OnInit {

  // set the current year
  year: number = new Date().getFullYear();

  errorMessage: string='';
  constructor( private route: ActivatedRoute, private router: Router,private translate:TranslateService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.errorMessage = params['message'] || this.translate.instant('general.unexpectedError');
    });
  }
  goToHome(): void {
    this.router.navigate(['/']);
  }
}
